import { countries } from 'country-city-location';
import { countries as countriesB } from 'countries-list';
import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';

export const findCoordinatesByCountry = (country = '') => {
  const c = countries.find((c) => c.Alpha2Code === country);
  if (c) {
    return [c.Latitude, c.Longitude];
  }
  return [0, 0];
}

export const getCountryName = (val) => {
  const opt = countriesB[val];
  if (opt) {
    return opt.name;
  }
  return val;
}

export const toDegreesMinutesAndSeconds = (coordinate) => {
  var absolute = Math.abs(coordinate);
  var degrees = Math.floor(absolute);
  var minutesNotTruncated = (absolute - degrees) * 60;
  var minutes = Math.floor(minutesNotTruncated);
  var seconds = Math.floor((minutesNotTruncated - minutes) * 60);
  return degrees + "°" + minutes + "'" + seconds;
}

export const convertDMS = (lat, lng) => {
  const latitude = toDegreesMinutesAndSeconds(lat);
  const latitudeCardinal = lat >= 0 ? 'N' : 'S';
  const longitude = toDegreesMinutesAndSeconds(lng);
  const longitudeCardinal = lng >= 0 ? 'E' : 'W';
  return [(latitude + '"' + latitudeCardinal), (longitude + '"' + longitudeCardinal)];
}

export const useCountry = () => {
  const options = useSelector((state) => state.authentication.options);

  const getCountry = useCallback((v) => {
    const _opt = (options?.countries || []).find((o) => o.value === v);

    if (_opt) {
      return _opt.label || '--';
    }

    return v;
  }, [options])

  const countries = useMemo(() => {
    return options?.countries || [];
  }, [options]);

  const getCountryDetemination = useCallback((v) => {
    const _opt = (options?.countries || []).find((o) => o.value === v);

    if (_opt) {
      return _opt.determination || 'Low Risk';
    }

    return 'Undetermined';
  }, [options])

  return { getCountry, countries, getCountryDetemination };
};
